import { render, staticRenderFns } from "./SSOGoContinue.vue?vue&type=template&id=092ca228"
import script from "./SSOGoContinue.vue?vue&type=script&lang=ts"
export * from "./SSOGoContinue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports